import type { ReactNode } from "react";

/**
 * A titled group of fields inside a larger form.
 *
 * A real `<fieldset>` with a real `<legend>`, not a styled div: assistive
 * technology announces the legend when focus enters the group, which is the
 * entire point of grouping fields.
 *
 * `divided` draws the rule separating it from the section above — the first
 * section in a form omits it.
 */
export function FormSection({
  legend,
  children,
  divided = true,
}: {
  legend: string;
  children: ReactNode;
  divided?: boolean;
}) {
  return (
    <fieldset className={`space-y-4 ${divided ? "border-t border-line-hairline pt-5" : ""}`}>
      <legend className="mb-1 text-xs font-semibold uppercase tracking-wide text-muted-subtle">
        {legend}
      </legend>
      {children}
    </fieldset>
  );
}
